import DeleteModalConfirmation from './delete-modal-confirmation';

export default DeleteModalConfirmation;
